import { addCyPrefixToIDs } from 'moet-test-utils/cypress/utils';

const cyPrefix = 'containers_selling_countries_container';

let ids = {
  SELECT_SELLING_COUNTRIES: 'SELECT_SELLING_COUNTRIES',
  SELECTED_COUNTRY_BATCH: 'SELECTED_COUNTRY_BATCH',
  BTN_CLEAR: 'BTN_CLEAR',
  BTN_BACK: 'BTN_BACK',
  BTN_SUBMIT: 'BTN_SUBMIT',
};
ids = addCyPrefixToIDs(cyPrefix, ids);

export const CY_SELLING_COUNTRIES_CONTAINER_IDS = ids;
